module.exports = __webpack_public_path__ + "img/anaqueles_colas_frutales.852208d3.png";